import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { noop } from '@lux/helpers';

import IconTick from '../../assets/svgs/tick.svg';

const CheckBoxWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  height: 1.5rem;
  width: 1.5rem;
  position: relative;
  vertical-align: middle;
  border-radius: 4px;

  input {
    position: absolute;
    top: 0;
    left: -99999px;

    & + span {
      height: 1.5rem;
      width: 1.5rem;
      display: block;
      cursor: pointer;
      background: ${p => p.theme.colours.white};
      border-radius: 4px;
      border: 1px solid ${p => p.theme.colours.grey_e1};
    }

    &:checked + span {
      background: ${p => p.theme.colours.link};
      border: 1px solid ${p => p.theme.colours.link};
    }

    &:disabled + span {
      border: 1px solid ${p => p.theme.colours.grey_e1};
      background: ${p => p.theme.colours.haze};
      pointer-events: none;
    }

    &:not(:disabled) + span:hover {
      border: 1px solid ${p => p.theme.colours.cerulean};
    }
  }

  svg,
  path {
    padding: ${p => p.theme.spacing(0.5)};
    fill: none;
    stroke: ${p => p.theme.colours.white};
    stroke-width: 2px;
  }
`;

class CheckBox extends Component {
  handleChange = e => {
    if (!this.props.disabled) {
      this.props.onChange(e);
    }
  };

  render() {
    const {
      checked,
      form,
      id,
      name,
      onFocus,
      onBlur,
      disabled,
      onChange,
      ...rest
    } = this.props;

    return (
      <CheckBoxWrapper
        onClick={this.handleChange}
        checked={checked}
        data-testid="checkbox-wrapper"
      >
        <input
          type="checkbox"
          form={form}
          id={id}
          name={name}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          checked={checked}
          {...rest}
        />
        <span>
          {checked && (
            <IconTick width={22} height={22} data-testid="icon-tick" />
          )}
        </span>
      </CheckBoxWrapper>
    );
  }
}

CheckBox.defaultProps = {
  checked: false,
  disabled: false,
  onChange: noop,
  onFocus: noop,
  onBlur: noop
};

CheckBox.propTypes = {
  /** Default state */
  checked: PropTypes.bool,
  /** Extra class to apply to element */
  className: PropTypes.string,
  /** ID of input */
  id: PropTypes.string,
  /** Set the form */
  form: PropTypes.string,
  /** Disable the element */
  disabled: PropTypes.bool,
  /** Name of input field */
  name: PropTypes.string,
  /** Value binded to this element */
  value: PropTypes.string,
  /** On blur function */
  onBlur: PropTypes.func,
  /** On change function */
  onChange: PropTypes.func,
  /** On click function */
  onClick: PropTypes.func,
  /** On focus function */
  onFocus: PropTypes.func
};

export default CheckBox;
